//Based upon https://www.alus.it/pubs/CodiceFiscale/index.php?lang=en
const ITALIAN_FISCAL_CODE_FORMAT = '^[a-zA-Z0-9]{16}$'

const ODD_CHARACTERS_MAP = new Map([
  ['0', 1],
  ['1', 0],
  ['2', 5],
  ['3', 7],
  ['4', 9],
  ['5', 13],
  ['6', 15],
  ['7', 17],
  ['8', 19],
  ['9', 21],
  ['A', 1],
  ['B', 0],
  ['C', 5],
  ['D', 7],
  ['E', 9],
  ['F', 13],
  ['G', 15],
  ['H', 17],
  ['I', 19],
  ['J', 21],
  ['K', 2],
  ['L', 4],
  ['M', 18],
  ['N', 20],
  ['O', 11],
  ['P', 3],
  ['Q', 6],
  ['R', 8],
  ['S', 12],
  ['T', 14],
  ['U', 16],
  ['V', 10],
  ['W', 22],
  ['X', 25],
  ['Y', 24],
  ['Z', 23],
])
const EVEN_CHARACTERS_MAP = new Map([
  ['0', 0],
  ['1', 1],
  ['2', 2],
  ['3', 3],
  ['4', 4],
  ['5', 5],
  ['6', 6],
  ['7', 7],
  ['8', 8],
  ['9', 9],
  ['A', 0],
  ['B', 1],
  ['C', 2],
  ['D', 3],
  ['E', 4],
  ['F', 5],
  ['G', 6],
  ['H', 7],
  ['I', 8],
  ['J', 9],
  ['K', 10],
  ['L', 11],
  ['M', 12],
  ['N', 13],
  ['O', 14],
  ['P', 15],
  ['Q', 16],
  ['R', 17],
  ['S', 18],
  ['T', 19],
  ['U', 20],
  ['V', 21],
  ['W', 22],
  ['X', 23],
  ['Y', 24],
  ['Z', 25],
])

function isValidFormat(fiscalCode: string) {
  if (fiscalCode) {
    return new RegExp(ITALIAN_FISCAL_CODE_FORMAT).test(fiscalCode)
  }
  return false
}

function calculateCheckSumDigit(fiscalCodeWithoutCheckSumDigit: string) {
  let sum = 0
  for (let i = 0; i < fiscalCodeWithoutCheckSumDigit.length; i++) {
    const fiscalCodeCharacter = fiscalCodeWithoutCheckSumDigit.charAt(i)
    const value =
      i % 2 === 0
        ? ODD_CHARACTERS_MAP.get(fiscalCodeCharacter)
        : EVEN_CHARACTERS_MAP.get(fiscalCodeCharacter)
    if (value) {
      sum += value
    }
  }
  const remainder = sum % 26
  return String.fromCharCode(remainder + 65)
}

export function isTaxNumberValid(taxNumber: string) {
  if (!isValidFormat(taxNumber)) {
    return false
  }
  const fiscalCodeUpperCase = taxNumber.toUpperCase()
  const fiscalCodeWithoutCheckDigit = fiscalCodeUpperCase.substring(0, 15)
  const expectedCheckSumDigit = fiscalCodeUpperCase.charAt(15)
  const calculatedCheckSumDigit = calculateCheckSumDigit(
    fiscalCodeWithoutCheckDigit
  )
  return calculatedCheckSumDigit === expectedCheckSumDigit
}
